import { Group, Stack } from '@mantine/core';
import { DateTimePicker } from '@mantine/dates';
import type { BackgroundJobType } from '@repo/api-codegen';
import { useApiGetBackgroundJob } from '@repo/api-codegen';
import { Button, ListBox } from '@repo/foundations';
import { useState } from 'react';
import BackgroundJobCard from './BackgroundJobCard';
import BackgroundJobCreate from './BackgroundJobCreate';

function BackgroundJobPage() {
	const [type, setType] = useState<BackgroundJobType>('indexing');
	const [since, setSince] = useState<Date>(
		new Date(new Date().setHours(0, 0, 0, 0) - 1000 * 60 * 60 * 24)
	);

	const [opened, setOpened] = useState(false);
	const { data: backgroundJobs, refetch } = useApiGetBackgroundJob({
		queryParams: { type: type, since: since.toISOString() },
	});

	return (
		<Stack
			p="sm"
			w="100%"
			mih="100vh"
			sx={{
				overflowX: 'scroll',
			}}
		>
			<BackgroundJobCreate />
			<Group>
				<ListBox
					opened={opened}
					onOpenChange={(newOpened) => setOpened(newOpened)}
					closeOnEscape
				>
					<ListBox.Target>
						<Button onClick={() => setOpened(true)}>Job Type: {type}</Button>
					</ListBox.Target>
					<ListBox.ItemsDropdown
						items={['indexing', 'bg_admin'] as BackgroundJobType[]}
						renderItem={(item) => (
							<ListBox.Item
								onClick={() => {
									setType(item);
									setOpened(false);
								}}
							>
								{item}
							</ListBox.Item>
						)}
					/>
				</ListBox>
				<DateTimePicker
					label="Since"
					value={since}
					onChange={(newSince) => setSince(newSince ?? new Date())}
				/>
			</Group>
			{backgroundJobs?.map((job) => (
				<BackgroundJobCard key={job.id} job={job} onRefresh={() => refetch()} />
			))}
		</Stack>
	);
}

export default BackgroundJobPage;
